import eventBus from 'pubsub-js';

export const functionalities = {
  Relation: 1,
  RegistrationOwn: 2,
  RegistrationOthers: 4,
  Pricelist: 8,
  InvoiceDraft: 16,
  InvoiceFinal: 32,
  CompanyOwn: 64,
  Settings: 128,
  TaskTemplates: 256,
  InvoiceTransaction: 512,
  Documents: 1024,
  Users: 2048,
  RentabilityReport: 4096,
  Tags: 8192,
  InteractionsOwn: 16384,
  InteractionsOthers: 32768,
  TaskSchedules: 65536,
  PlannedTask: 131072,
  Todo: 262144,
  IntraCompanyInvoice: 524288,
  FreeInvoiceCreditNote: 1048576,
  RegistrationsPerReports: 2097152,
  AbsenceReports: 4194304,
  ChecklistInvoicingReport: 8388608,
  AbsenceAndCounters: 16777216,
  Teams: 33554432,
  EmployeeInternalPrice: 67108864,
  BudgetHours: 134217728,
  TrainingManagement: 268435456,
  BudgetAmounts: 536870912,
  CapacityPlanning: 1073741824,
  AI: 2147483648,
};

export const privileges = {
  Read: 1,
  Update: 2,
  Create: 4,
  Delete: 8,
  All: 15, // All crud actions
  Execute: 16,
  Syneton: 32,
};
export const features = {
  RelationUserAccess: 1,
  //Unused: 2,
  //Unused: 4,
  //Unused: 8,
  ReportPerformanceBalance: 16,
  TenantMoore: 32,
  Gmail: 64,
  IntraCompanyBilling: 128,
  ConnectOpenTheBox: 256,
  AI: 512,
  ReferenceYear: 1024,
  TaskflowBilling: 2048,
  AssignmentAnalysis: 4096,
  Training: 8192,
  DocumentTagUserAccessRestriction: 1 << 14,
  CapacityPlanning: 1 << 15,
};

const parseTokenRole = role => {
  const perms = role.split(';');
  const result = {};
  perms.forEach(perm => {
    const permission = perm.split(':');
    if (permission.length !== 2) return;
    const functionality = parseInt(permission[0], 10);
    const privilege = parseInt(permission[1], 10);

    Object.keys(functionalities).forEach(key => {
      const f = functionalities[key];
      if (Math.floor(functionality / f) % 2 !== 0) {
        // eslint-disable-next-line no-bitwise
        result[f] = (result[f] || 0) | privilege;
      }
    });
  });

  return result;
};

export const parsePrivilege = privilege => {
  if (typeof privilege === 'string') {
    const key = Object.keys(privileges).find(x => x.toLowerCase() === privilege.toLowerCase());
    return key ? privileges[key] : 0;
  }
  if (typeof privilege === 'number') return privilege;
  return 0;
};
export const parseFunctionality = functionality => {
  if (typeof functionality === 'string') {
    const key = Object.keys(functionalities).find(
      x => x.toLowerCase() === functionality.toLowerCase(),
    );
    return key ? functionalities[key] : 0;
  }
  if (typeof functionality === 'number') return functionality;
  return 0;
};
export const parseFeature = feature => {
  if (typeof feature === 'string') {
    const key = Object.keys(features).find(x => x.toLowerCase() === feature.toLowerCase());
    return key ? features[key] : 0;
  }
  if (typeof feature === 'number') return feature;
  return 0;
};

export default class AuthService {
  user = {};
  manager = {};

  static setConfig(config) {
    this.user = config.user;
    this.manager = config.manager;
  }

  static getToken() {
    return this.user ? this.user.access_token : null;
  }

  static getUserId() {
    return this.user ? this.user.profile.Sid : null;
  }
  static getTenantId() {
    return this.user ? this.user.profile.GroupSid : null;
  }

  static getEmail() {
    return this.user ? this.user.profile.Email : null;
  }

  static getName() {
    return this.user ? this.user.profile.Name : null;
  }

  static getClaims() {
    return this.user ? this.user.profile : null;
  }

  static signinSilent() {
    return this.manager.signinSilent().then(user => {
      eventBus.publish('signinSilentCompleted', user);
      return user;
    });
  }

  static functionalities = functionalities;
  static privileges = privileges;

  static hasPermission({ functionality, privilege = privileges.All }) {
    if (!this.user || !this.user.profile || !this.user.profile.Role || !functionality) return false;
    const permissions = parseTokenRole(this.user.profile.Role);
    if (!permissions) return false;

    const parsedFunctionality = parseFunctionality(functionality);
    if (!permissions[parsedFunctionality]) return false;

    // eslint-disable-next-line no-bitwise
    return (permissions[parsedFunctionality] & parsePrivilege(privilege)) > 0;
  }

  static hasFeature(feature) {
    if (!this.user || !this.user.profile || !this.user.profile.WindowsSubAuthority || !feature)
      return false;
    const security = parseFeature(feature);
    let permissions = 0;

    try {
      permissions = parseInt(this.user.profile.WindowsSubAuthority);
    } catch (ex) {
      permissions = 0;
    }
    return (security & permissions) > 0; // eslint-disable-line no-bitwise
  }

  // Is support user?
  static isSupport() {
    if (!this.user || !this.user.profile) return false;
    return !!this.user.profile.su;
  }

  static tenantConfiguration() {
    if (!this.user || !this.user.profile) return null;
    try {
      return parseInt(this.user.profile.TenantConfiguration);
    } catch (ex) {
      console.error(ex);
      return null;
    }
  }
}
